"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StatusPage;
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRouterDom = require("react-router-dom");
var _Page = _interopRequireDefault(require("../Page"));
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    icon: {
      height: 80,
      marginBottom: theme.spacing(8),
      marginTop: theme.spacing(8),
      width: 80
    },
    page: {
      alignItems: 'center',
      display: 'flex',
      flex: 2,
      flexDirection: 'column',
      justifyContent: 'center'
    },
    title: {
      marginTop: theme.spacing(4)
    }
  };
});
function StatusPage(_ref) {
  var buttonLink = _ref.buttonLink,
    buttonTextKey = _ref.buttonTextKey,
    Icon = _ref.Icon,
    id = _ref.id,
    textBottomKey = _ref.textBottomKey,
    textTopKey = _ref.textTopKey,
    titleKey = _ref.titleKey;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_Page.default, {
    className: classes.page,
    id: id,
    titleKey: titleKey
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    align: "center",
    className: classes.title,
    id: "".concat(id, "Title"),
    variant: "h5"
  }, titleKey && /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: titleKey
  })), /*#__PURE__*/_react.default.createElement(Icon, {
    className: classes.icon,
    color: "disabled",
    id: "".concat(id, "Icon")
  }), textTopKey && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    id: "".concat(id, "TopText"),
    variant: "subtitle1"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: textTopKey
  })), textBottomKey && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    id: "".concat(id, "BottomText"),
    variant: "subtitle1"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: textBottomKey
  })), /*#__PURE__*/_react.default.createElement(_material.Button, {
    component: _reactRouterDom.Link,
    id: "".concat(id, "Button"),
    to: buttonLink || '/',
    variant: "contained"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: buttonTextKey
  })));
}